import { SESSION_TIMEOUT_CONSTANTS } from '../api/apps/data'

// Time conversion utilities
export const TimeUtils = {
    // Convert seconds to human readable format
    secondsToHumanReadable: (seconds: number): string => {
        if (seconds < 60) {
            return `${seconds} second${seconds !== 1 ? 's' : ''}`
        } else if (seconds < 3600) {
            const minutes = Math.floor(seconds / 60)
            return `${minutes} minute${minutes !== 1 ? 's' : ''}`
        } else if (seconds < 86400) {
            const hours = Math.floor(seconds / 3600)
            return `${hours} hour${hours !== 1 ? 's' : ''}`
        } else {
            const days = Math.floor(seconds / 86400)
            return `${days} day${days !== 1 ? 's' : ''}`
        }
    },

    // Convert various time inputs to seconds
    convertToSeconds: (value: number, unit: 'seconds' | 'minutes' | 'hours' | 'days'): number => {
        switch (unit) {
            case 'seconds': return value
            case 'minutes': return value * 60
            case 'hours': return value * 3600
            case 'days': return value * 86400
            default: return value
        }
    },

    // Convert seconds to the most appropriate unit
    secondsToUnit: (seconds: number): { value: number, unit: 'seconds' | 'minutes' | 'hours' | 'days' } => {
        if (seconds >= 86400 && seconds % 86400 === 0) {
            return { value: seconds / 86400, unit: 'days' }
        } else if (seconds >= 3600 && seconds % 3600 === 0) {
            return { value: seconds / 3600, unit: 'hours' }
        } else if (seconds >= 60 && seconds % 60 === 0) {
            return { value: seconds / 60, unit: 'minutes' }
        } else {
            return { value: seconds, unit: 'seconds' }
        }
    }
}

// Validation utilities for session timeouts
export const SessionTimeoutValidation = {
    validateActivityTimeout: (seconds: number): { isValid: boolean, error?: string } => {
        if (seconds < SESSION_TIMEOUT_CONSTANTS.MIN_ACTIVITY_TIMEOUT) {
            return { 
                isValid: false, 
                error: `Minimum activity timeout is ${TimeUtils.secondsToHumanReadable(SESSION_TIMEOUT_CONSTANTS.MIN_ACTIVITY_TIMEOUT)}` 
            }
        }
        if (seconds > SESSION_TIMEOUT_CONSTANTS.MAX_ACTIVITY_TIMEOUT) {
            return { 
                isValid: false, 
                error: `Maximum activity timeout is ${TimeUtils.secondsToHumanReadable(SESSION_TIMEOUT_CONSTANTS.MAX_ACTIVITY_TIMEOUT)}` 
            }
        }
        return { isValid: true }
    },

    validateTTL: (seconds: number): { isValid: boolean, error?: string } => {
        if (seconds < SESSION_TIMEOUT_CONSTANTS.MIN_TTL) {
            return { 
                isValid: false, 
                error: `Minimum TTL is ${TimeUtils.secondsToHumanReadable(SESSION_TIMEOUT_CONSTANTS.MIN_TTL)}` 
            }
        }
        if (seconds > SESSION_TIMEOUT_CONSTANTS.MAX_TTL) {
            return { 
                isValid: false, 
                error: `Maximum TTL is ${TimeUtils.secondsToHumanReadable(SESSION_TIMEOUT_CONSTANTS.MAX_TTL)}` 
            }
        }
        return { isValid: true }
    }
}

// Helper text for the form fields
export const TIMEOUT_HELP_TEXT = {
    activityTimeout: "How long a user can be inactive before their session expires. The session will be refreshed on any activity within this window.",
    ttl: "Maximum lifetime of a session from creation. Once this time is reached, the session cannot be refreshed and user must log in again."
}